import React from 'react';

const AmsaleLogo = () => (
  <svg width="127" height="18" viewBox="0 0 127 18" fill="none" xmlns="http://www.w3.org/2000/svg" itemProp="logo" className="lazyload">
    <path fillRule="evenodd" clipRule="evenodd"
      d="M26.7556 17.8689H28.1173V3.655L34.7823 10.9889L41.4234 3.55945L41.4473 17.8689H42.809V0.358337C42.0923 1.09889 41.0173 2.24556 39.8706 3.44C37.9117 5.51834 35.7617 7.78778 35.0928 8.55223L34.7345 8.95834L34.3762 8.55223C33.6834 7.78778 31.5812 5.54223 29.6462 3.48778C28.5234 2.29334 27.4484 1.17056 26.7556 0.453893V17.8689Z"
      fill="#00372C"
    />
    <path fillRule="evenodd" clipRule="evenodd"
          d="M96.9888 17.8689H107.978V16.5311C105.995 16.5311 99.2343 16.5311 98.8282 16.5311H98.3504V0.64502H96.9888V17.8689Z"
          fill="#00372C"
    />
    <path fillRule="evenodd" clipRule="evenodd"
          d="M115.431 0.621094V17.8211H126.826V16.5072H116.817V9.41221L126.444 9.38832V8.05054H116.817V1.95887H126.731V0.621094H115.431Z"
          fill="#00372C"
    />
    <path fillRule="evenodd" clipRule="evenodd"
          d="M0 17.8689H1.48111L3.89389 13.2822H14.4528L16.8656 17.8689H18.3467L9.17334 0.429993L0 17.8689ZM9.17334 3.29666L13.6644 11.8967H4.65833L9.17334 3.29666Z"
          fill="#00372C"
    />
    <path fillRule="evenodd" clipRule="evenodd"
          d="M78.1883 0.429993L69.0388 17.8689H70.5199L72.9327 13.2822H83.4916L85.9044 17.8689H87.3855L78.1883 0.429993ZM73.6972 11.8967L78.1883 3.29666L82.6794 11.8967H73.6972Z"
          fill="#00372C"
    />
    <path fillRule="evenodd" clipRule="evenodd"
          d="M56.8077 3.84611C56.0432 5.63778 55.9954 7.59667 56.7121 9.41222C57.3093 10.8933 57.2616 12.5178 56.6166 13.9511C56.0193 15.2411 54.9921 16.2683 53.6782 16.8417V18.1794C55.5177 17.5106 56.951 16.1967 57.7393 14.4528C58.5277 12.7089 58.5754 10.75 57.8588 8.93445C57.2616 7.42945 57.2854 5.805 57.9304 4.32389C58.5038 3.03389 59.4593 1.98278 60.7016 1.36167V0C58.9577 0.716667 57.5721 2.07833 56.8077 3.84611Z"
          fill="#00372C"
    />
  </svg>
);

const AngleDownIcon = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.6666 5.91667L7.99998 10.5833L3.33331 5.91667" stroke="#26574D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CloseIcon = () => (
  <svg aria-hidden="true" focusable="false" role="presentation" className="icon icon-close" viewBox="0 0 37 40">
    <path d="M21.3 23l11-11c.8-.8.8-2 0-2.8-.8-.8-2-.8-2.8 0l-11 11-11-11c-.8-.8-2-.8-2.8 0-.8.8-.8 2 0 2.8l11 11-11 11c-.8.8-.8 2 0 2.8.4.4.9.6 1.4.6s1-.2 1.4-.6l11-11 11 11c.4.4.9.6 1.4.6s1-.2 1.4-.6c.8-.8.8-2 0-2.8l-11-11z" />
  </svg>
);

const HamburgerIcon = () => (
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.2858 0.857117H0.714355" stroke="#00372C" strokeWidth="1.42857" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M19.2858 8H0.714355" stroke="#00372C" strokeWidth="1.42857" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M19.2858 15.1428H0.714355" stroke="#00372C" strokeWidth="1.42857" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const SearchIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.45721 16.2C12.7335 16.2 16.2001 12.7334 16.2001 8.45715C16.2001 4.18089 12.7335 0.714294 8.45721 0.714294C4.18095 0.714294 0.714355 4.18089 0.714355 8.45715C0.714355 12.7334 4.18095 16.2 8.45721 16.2Z" stroke="#00372C" strokeWidth="1.42857" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M19.2859 19.2857L13.9287 13.9286" stroke="#00372C" strokeWidth="1.42857" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ShoppingBagIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.4 17.7C18.4225 17.9004 18.4023 18.1033 18.3407 18.2954C18.2792 18.4875 18.1777 18.6643 18.0428 18.8143C17.9077 18.9641 17.7423 19.0835 17.5576 19.1648C17.373 19.2461 17.1732 19.2873 16.9714 19.2857H3.02855C2.8268 19.2873 2.62701 19.2461 2.44234 19.1648C2.25766 19.0835 2.0923 18.9641 1.95712 18.8143C1.82231 18.6643 1.72079 18.4875 1.65923 18.2954C1.59768 18.1033 1.57748 17.9004 1.59998 17.7L2.85712 6.42859H17.1428L18.4 17.7Z" stroke="#00372C" strokeWidth="1.42857" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6.42847 6.42858V4.28572C6.42847 3.33852 6.80474 2.43011 7.47451 1.76034C8.14429 1.09057 9.05269 0.714294 9.9999 0.714294C10.9471 0.714294 11.8555 1.09057 12.5253 1.76034C13.195 2.43011 13.5713 3.33852 13.5713 4.28572V6.42858" stroke="#00372C" strokeWidth="1.42857" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const UserIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 10C12.5642 10 14.6429 7.92133 14.6429 5.35715C14.6429 2.79297 12.5642 0.714294 10 0.714294C7.43583 0.714294 5.35715 2.79297 5.35715 5.35715C5.35715 7.92133 7.43583 10 10 10Z" stroke="#00372C" strokeWidth="1.42857" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18.8286 19.2857C18.2288 17.4156 17.0507 15.7841 15.464 14.6267C13.8773 13.4692 11.964 12.8455 10 12.8455C8.036 12.8455 6.12273 13.4692 4.53603 14.6267C2.94933 15.7841 1.77118 17.4156 1.17143 19.2857H18.8286Z" stroke="#00372C" strokeWidth="1.42857" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export { AmsaleLogo, AngleDownIcon, CloseIcon, HamburgerIcon, SearchIcon, ShoppingBagIcon, UserIcon };
